<div class="virtual-scroll-container">
  <div class="search-container-scroll">
    <input type="text" [(ngModel)]="searchOutputBody" matInput placeholder="Search"  />
    <button   [disabled]="!searchOutputBody" (click)="onSearch()" class="icon-btn">
      <img src="assets/img/search.png" style="width: 25px;">
    </button>
    <button (click)="onClear()" class="icon-btn">
      <img src="assets/img/reset.svg" style="width: 20px;">
    </button>
  </div>
  <div>
    <pre class="no-margin">
      <cdk-virtual-scroll-viewport [itemSize]="20" class="virtual-viewport">
        <div *cdkVirtualFor="let item of filteredValueOutputBody" class="virtual-item-height">
            {{item}}
        </div> 
      </cdk-virtual-scroll-viewport>
    </pre>
  </div>
</div>